import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Grid, Typography, TextField, Box } from '@mui/material'
import SaveIcon from '@mui/icons-material/Save'
import ClearIcon from '@mui/icons-material/Clear'
import { useFormik } from 'formik'
import * as Yup from 'yup';

interface IConfirmModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: (note: string) => void;
  title: string;
  message: string;
}

const ConfirmCancelModal = ({ open, onClose, onConfirm, title, message }: IConfirmModalProps) => {
  const formik = useFormik({
    initialValues: {
      note: '',
    },
    validationSchema: Yup.object().shape({
      note: Yup.string().required('กรุณากรอกหมายเหตุ'),
    }),
    onSubmit: (values) => {
      onConfirm(values.note)
    },
  })

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth={'sm'} aria-describedby="alert-dialog-slide-description">
      <Box component="form" mt={1} onSubmit={formik.handleSubmit}>
        <DialogTitle>{title}</DialogTitle>
        <Box>
          <DialogContent>
            <TextField
              fullWidth
              multiline
              rows={4}
              id="note"
              label="หมายเหตุ"
              name="note"
              value={formik.values.note}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.note && Boolean(formik.errors.note)}
              helperText={formik.touched.note && formik.errors.note}
            />
          </DialogContent>
        </Box>
        <DialogActions>
          <Button
            startIcon={<ClearIcon />}
            color="inherit"
            onClick={onClose}
            size="large"
            variant="contained"
          >
            ยกเลิก
          </Button>
          <Button
            startIcon={<SaveIcon />}
            color="primary"
            type="submit"
            size="large"
            variant="contained"

          >
            ยืนยัน
          </Button>
        </DialogActions>
      </Box>
    </Dialog>
  )
}

export default ConfirmCancelModal
